import { MakerWithCategoriesResponse } from "@/web-client/api";
import Link from "next/link";
import { FC } from "react";
import IconArrowRight from "@/assets/imgs/svg/icon-arrow-right.svg";
import useDevice from "@/hooks/useDevice";
import { theme } from "tailwind.config";

interface Props {
  maker: MakerWithCategoriesResponse;
}

const MakerHeader: FC<Props> = ({ maker }): JSX.Element => {
  const { isPc } = useDevice();

  return (
    <header className="flex flex-col space-y-16 laptop:p-32 p-16">
      <div className="relative flex justify-between items-center bg-white rounded-sm overflow-hidden p-12 hover:bg-gray-100 transition-all">
        <div className="flex items-center space-x-16">
          <img
            className="object-contain aspect-square w-[80px] h-[80px] rounded-full border border-primary"
            src={
              maker.icon
                ? maker.icon.urls.small
                : "/imgs/default_maker_icon.png"
            }
            alt={maker.name}
          />
          <h1 className="text-sm laptop:text-base font-bold tracking-widest">
            {maker.name}
          </h1>
        </div>
        <div className="flex items-center text-sm space-x-8">
          {isPc && <p className="text-link">このメーカーについて</p>}
          <IconArrowRight
            width={24}
            height={24}
            fill={theme.colors.gray[950]}
          />
        </div>

        <Link className="absolute inset-0" href={`/makers/${maker.id}`}></Link>
      </div>
    </header>
  );
};
export default MakerHeader;
